
import { SubscriptionTier } from './types';

// Check if a user can access a specific feature based on their subscription
export const canAccessFeature = (
  subscriptionTier: string,
  featureName: string
): boolean => {
  // SECURITY: Prefer server-side validation via Edge Functions.
  // Keep a minimal, conservative client-side check to avoid accidental exposure.
  const tier = (subscriptionTier || 'free').toLowerCase();
  const premiumFeatures = new Set(['advanced_roleplay', 'mentor_feedback', 'comprehensive_reviews', 'coach_progress', 'technique_analysis']);
  if (premiumFeatures.has(featureName)) {
    return tier === 'premium';
  }
  // Default safe behavior: treat unknown features as premium-gated
  return !premiumFeatures.has(featureName);
};
